import React from 'react';
import './Stepper.scss';
import classNames from 'classnames';

const Stepper = ({ steps, activeStepIndex }) => {
  return (
    <div className="stepper_controller">
      <div className="card">
        <div className="card_content">
          <ul className="stepper_group">
            {steps?.map((item) => (
              <li
                key={item?.stepId}
                className={classNames({
                  status_current: item?.stepId === activeStepIndex,
                  status_success: item?.stepId < activeStepIndex
                })}
              >
                <div className="inside_content">
                  <div className="count_number">
                    <span className="num_text">{item?.stepId}</span>
                  </div>
                  <div className="text_group">
                    <div className="step_title">{item?.name}</div>
                    {/* <div className="step_detials">{item?.detail}</div> */}
                  </div>
                </div>
              </li>
            ))}
          </ul>
          {/* <div className="show_hide">
                        <span className="action_text">Hide Stages</span>
                    </div> */}
        </div>
      </div>
    </div>
  );
};
export default Stepper;
